import { atom } from 'recoil';

export const initialMileageStateAtom = atom<number>({
  key: 'initialMileageState',
  default: 0,
});
